import { useLazyQuery } from "@apollo/client";
import styled from "@emotion/styled";
import { IconDownload } from "@kompare/kompare-ui-library";
import React from "react";
import { i18n, setGlobalLoading, showMessage, useAppDispatch } from "src/common";
import { getFileByIdAdditional } from "src/common/api/apollo/additional/queries";
import { GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables, GetTermsAndConditionsFromFilesQuery } from "src/common/api/apollo/additional/types/types";
import { Flex, Text } from "src/components";
import { colors } from "src/theme";

const FlexStyle = styled(Flex)<{ isModal?: boolean }>(({ isModal }) => ({
  marginTop: 32,
  ...(isModal && {
    marginTop: 0
  })
}))

const LinkStyle = styled.a({
  color: colors.text7,
  cursor: 'pointer',
  textDecoration: 'none',

  '&:hover': {
    color: colors.text5
  },
})

const LogoContainerStyle = styled(Flex)({
  width: 64,
  height: 24,
})

const LogoStyle = styled.img({
  maxWidth: '100%',
  height: 37,
  objectFit: 'contain',
  objectPosition: 'left',
})

export const TermsCard = ({ termsAndConditions, isModal }: { termsAndConditions: GetTermsAndConditionsFromFilesQuery['getTermsAndConditionsFromFiles'], isModal?: boolean }) => {
  const dispatch = useAppDispatch();
  const [getFileById] = useLazyQuery<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>(getFileByIdAdditional, {
    fetchPolicy: 'network-only',
  });

  const download = (e: React.MouseEvent<HTMLAnchorElement>, fileId: string) => {
    dispatch(setGlobalLoading(true));
    e.preventDefault();
    getFileById({ variables: { fileId } }).then((result) => {
      const url = result.data?.getTermsAndConditionsById?.downloadUrl;
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }).catch(() => {
      dispatch(setGlobalLoading(false));
      dispatch(showMessage({ message: i18n.t('common.messages.error'), type: 'error', duration: 5000 }));
    }).finally(() => {
      dispatch(setGlobalLoading(false));
    });
  };
  if (!termsAndConditions) return null;
  return (
    <Flex vertical gap={32}>
      {!isModal && <Flex vertical gap={8}>
        <Text type="xLarge" bold>{i18n.t('pages.termsAndConditionsPage.title')}</Text>
      </Flex>
      }
      <Flex vertical gap={8}>
        <React.Fragment key={termsAndConditions.brandName}>
          {!isModal && (
            <Flex align="center" gap={12}>
              <LogoContainerStyle justify="start">
                a
                <LogoStyle src={termsAndConditions.logoUrl} alt={termsAndConditions.brandName} />
              </LogoContainerStyle>
              <Text type="base">{termsAndConditions.brandName}</Text>
            </Flex>
          )}
          <FlexStyle vertical gap={24} isModal={isModal}>
            {termsAndConditions.documents.map((doc) => (
              <Flex key={doc.fileId} justify="space-between" align="center" gap={12}>
                <Text color={colors.text2} type="base">{doc.fileName}</Text>
                <LinkStyle href="#" onClick={(e) => { download(e, doc.fileId) }} ><IconDownload width={20} height={20} /></LinkStyle>
              </Flex>
            ))}
          </FlexStyle>
        </React.Fragment>
      </Flex>
    </Flex>
  );
};